<template>
  <div style="display: flex; justify-content: center; align-items: center; height: calc(100vh - 80px); font-size: 24px">
    <div>本功能暂未开放，谢谢。</div>
  </div>
</template>

<script>
  export default {
    name: 'WxNotOpenPage'
  }
</script>

<style scoped>

</style>
